import React from 'react';
import { Bar, Button } from './mobileMenuButton.styles';
import { MOBILE_BUTTON_TYPES } from './mobileMenuButton.constans';
import { always, cond, equals } from 'ramda';

export const MobileMenuButton = ({ onClick, section, type = MOBILE_BUTTON_TYPES.SECTION }) => {
  const defaultProps = { type, onClick };
  return cond([
    [
      equals(MOBILE_BUTTON_TYPES.SECTION),
      always(
        <Button {...defaultProps} sectionIndex={section.index}>
          {section.number}
        </Button>
      ),
    ],
    [
      equals(MOBILE_BUTTON_TYPES.NORMAL),
      always(
        <Button {...defaultProps}>
          <Bar />
          <Bar />
          <Bar />
        </Button>
      ),
    ],
  ])(type);
};
